<h1 class="accent-background-element">Review Edit User</h1>

<mat-dialog-content class="smaller">
    <h3 [ngClass]="{'warn-text-element' :(currentUser?.firstName!=editedUser?.properties?.firstName) 
        || (currentUser?.lastName!=editedUser?.properties?.lastName)}">
    Full Name: <span class="not-bold">{{editedUser?.properties?.firstName}}
  {{editedUser?.properties?.lastName}}</span></h3>

  @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
    <div>
      <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.clinicId!=editedUser?.properties?.clinicId) }">
        Clinic: <span class="not-bold">{{[currentClinic?.clinicId, currentClinic?.clinicName,
      currentClinic?.addressLine1,currentClinic?.addressLine2].join(', ')}}</span></h3>
      <h3 [ngClass]="{ 'warn-text-element' :(currentClinicList!=currentUser?.shopList) }">Clinic List:
        <span class="not-bold">{{currentClinicList.join(', ')}}</span>
      </h3>
    </div>
  }
  @if (currentUser?.role==UserRolesEnum.ent) {
    <div>
      <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.entOfficeId!=editedUser?.properties?.entOfficeId) }">
        ENT Office: <span class="not-bold">{{[currentOffice?.entOfficeId, currentOffice?.entOfficeName,
      currentOffice?.addressLine1,currentOffice?.addressLine2].join(', ')}}</span></h3>
    </div>
  }

  <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.lang!=editedUser?.properties?.lang )}">
    Language: <span class="not-bold">{{editedUser?.properties?.lang}}</span></h3>
    @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
      <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.shopAdminAccess!=editedUser?.properties?.shopAdminAccess )}">
        Shop Manager: <span class="not-bold">{{editedUser?.properties?.shopAdminAccess? 'Yes':'No'}}</span></h3>
      }
      @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
        <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.countryShopsAccess!=editedUser?.properties?.countryShopsAccess )}">
          Country Manager: <span class="not-bold">{{editedUser?.properties?.countryShopsAccess? 'Yes':'No'}}</span></h3>
        }
        @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
          <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.patientManagerAccess!=editedUser?.properties?.patientManagerAccess )}">
            Patient Manager: <span class="not-bold">{{editedUser?.properties?.patientManagerAccess? 'Yes':'No'}}</span></h3>
          }
          @if ( currentUser?.role!=UserRolesEnum.dal) {
            <h3 [ngClass]="{ 'warn-text-element' :(currentUser?.advancedMode!=editedUser?.properties?.advancedMode )}">
              Advanced Dashboard User: <span class="not-bold">{{editedUser?.properties?.advancedMode? 'Yes':'No'}}</span></h3>
            }


            @if (currentUser?.role!=UserRolesEnum.ent&&currentUser?.role!=UserRolesEnum.dal&&(currentUser?.clinicId!=editedUser?.properties?.clinicId)) {
              <div
                >
                <br>
                  <br>
                    <br>
                      <p class="warn-text-element">Warning: You are about to change Tinnitus Clinic. This will have severe
                      consequences.</p>
                    </div>
                  }
                  @if (currentUser?.role==UserRolesEnum.ent&&(currentUser?.entOfficeId!=editedUser?.properties?.entOfficeId)) {
                    <div>
                      <br>
                        <br>
                          <br>
                            <p class="warn-text-element">Warning: You are about to change ENT Office. This will have severe
                            consequences.</p>
                          </div>
                        }
                      </mat-dialog-content>

                      <mat-dialog-actions>
                        <button mat-raised-button color="accent" (click)="goBack()">Go back</button>
                        <span class="spacer"></span>
                        <button mat-raised-button color="accent" (click)="onSubmit()">Continue</button>
                      </mat-dialog-actions>